import { createContext} from "react";

export const tokens=createContext<any>({});
